const defaultState = {
    fetch: false,
    message: "",
}
export const SEND_CHAT_REQUEST = "SEND_CHAT_REQUEST"
const SEND_CHAT_SUCCESS = "SEND_CHAT_SUCCESS"
const SEND_CHAT_FAILURE = "SEND_CHAT_FAILURE"
export const sendChatRequest = (payload) => ({type: SEND_CHAT_REQUEST, payload})
export const sendChatSuccess = (payload) => ({type: SEND_CHAT_SUCCESS, payload})
export const sendChatFailure = (payload) => ({type: SEND_CHAT_FAILURE, payload})
export const MESSAGE_CHAT_ERASE = "MESSAGE_CHAT_ERASE"
export const messageChatErase = (payload) => ({type: MESSAGE_CHAT_ERASE, payload})

const Chat_reducer = (state = defaultState, action) => {
    switch (action.type) {
        case SEND_CHAT_REQUEST:
            return {
                ...state,
                fetch: true
            }
        case SEND_CHAT_SUCCESS:
            return {
                ...state,
                fetch: false,
            }
        case SEND_CHAT_FAILURE:
            return {
                ...state,
                fetch: false,
                message: action.payload
            }
        case MESSAGE_CHAT_ERASE:
            return {
                ...state,
                message: action.payload
            }
        default:
            return state;
    }
}

export const getFetch = state => state.Chat_reducer.fetch;
export const getMessage = state => state.Chat_reducer.message

export default Chat_reducer;
